// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import closeIcon from '../../images/close-icon-shadow.png';
import styles from './styles';

class DeleteModal extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    modal: PropTypes.bool,
    closeModal: PropTypes.func,
    onAgree: PropTypes.func,
    question: PropTypes.string,
  };

  static defaultProps = {
    classes: {},
    modal: false,
    closeModal: () => { },
    onAgree: () => { },
    question: 'question?',
  };

  render() {
    const { classes, question } = this.props;
    return (
      <Modal open={this.props.modal} handleClose={this.props.closeModal}>
        <div className={classes.modalContainer}>
          <button className={classes.closeIconContainer} onClick={this.props.closeModal}>
            <img src={closeIcon} alt={'close-icon'} className={classes.closeIcon} />
          </button>
          <span className={classes.title}>{question}</span>
          <div className={classes.buttonsContainer}>
            <Button
              onPress={this.props.closeModal}
              outlined
              text={'cancel'}
              style={classNames(classes.buttonStyle, classes.buttonCancel)}
            />
            <Button
              onPress={this.props.onAgree}
              text={'delete'}
              style={classes.buttonStyle}
            />
          </div>
        </div>
      </Modal>);
  }
}

export default withStyles(styles)(DeleteModal);
